/* Fiche abonnement, mise en page v3 (refonte du 2026-10-06, retours d'Arthur du 2026-10-07).
   Balisage : snippets/pj-sub-v3.liquid.
   - « Un mois ou plus » est coché d'office ; « Moins d'un mois » ouvre l'eSIM voyage (illimitée d'abord) ;
   - « S'abonner » n'ajoute jamais directement : il ouvre une fenêtre où le client coche « c'est un
     abonnement », puis valide. La validation remplit la propriété masquée `_consent_abonnement`
     (texte | prix | heure ISO) et envoie le formulaire à pj-cart.js ;
   - la barre collante passe par la même fenêtre. */
(function () {
  var form = document.getElementById('pjSubForm');
  if (!form) return;
  var buy = document.getElementById('pjsBuy'), fork = document.getElementById('pjsFork'), trip = document.getElementById('pjsTrip');
  var cta = document.getElementById('pjsCta'), modal = document.getElementById('pjsModal');
  var chk = document.getElementById('pjsChk'), box = document.getElementById('pjsConsent'), err = document.getElementById('pjsErr');
  var ok = document.getElementById('pjsOk'), back = document.getElementById('pjsBack'), val = document.getElementById('pjsConsentVal');
  var tpl = { consent: document.getElementById('pjsConsentTpl'), cta: document.getElementById('pjsCtaTpl'), ok: document.getElementById('pjsOkTpl') };
  var lang = (document.documentElement.lang || 'fr').replace('_', '-');
  var confirmed = false, lastFocus = null;

  function fill(t, price) { return t ? t.innerHTML.split('§PRICE§').join(price) : ''; }
  function plain(html) { var d = document.createElement('div'); d.innerHTML = html; return d.textContent; }
  function tier() { var r = form.querySelector('input[name="id"]:checked'); return r && r.closest('.pjs-tier'); }
  function price() { var t = tier(); return t ? t.getAttribute('data-price') : ''; }

  /* Dates réelles des deux prochains prélèvements, dans la langue de la page. */
  try {
    var f = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }), d = new Date();
    document.querySelectorAll('[data-pjs-month]').forEach(function (el) {
      var n = +el.getAttribute('data-pjs-month');
      var target = new Date(d.getFullYear(), d.getMonth() + n, 1);
      var last = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
      target.setDate(Math.min(d.getDate(), last));
      el.textContent = f.format(target);
    });
  } catch (e) { /* « dans 1 mois », rendu par le serveur, reste */ }

  function syncTier() {
    var p = price(), t = tier();
    form.querySelectorAll('.pjs-tier').forEach(function (x) { x.classList.toggle('is-sel', x === t); });
    document.querySelectorAll('[data-pjs-amt]').forEach(function (a) { a.textContent = p; });
    var txt = form.querySelector('[data-pjs-consent]');
    if (txt && tpl.consent) txt.innerHTML = fill(tpl.consent, p);
    if (tpl.cta) cta.textContent = plain(fill(tpl.cta, p));
    if (tpl.ok) ok.textContent = plain(fill(tpl.ok, p));
    var sbName = document.querySelector('[data-pjs-sb-name]'), sbPrice = document.querySelector('[data-pjs-sb-price]');
    if (sbName && t) sbName.textContent = t.querySelector('.pjs-tier__n b').textContent;
    if (sbPrice) sbPrice.textContent = p;
  }

  function syncConsent() {
    box.classList.toggle('is-on', chk.checked);
    box.classList.remove('is-err');
    ok.classList.toggle('is-off', !chk.checked);
    if (chk.checked) err.hidden = true;
  }

  function openModal() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('pjs-modal-open');
    chk.focus();
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('pjs-modal-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* La question d'abord (« Un mois ou plus » est coché par le serveur). */
  fork.querySelectorAll('.pjs-opt').forEach(function (b) {
    b.addEventListener('click', function () {
      fork.querySelectorAll('.pjs-opt').forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
      var sub = b.getAttribute('data-o') === 'sub';
      trip.hidden = sub;
      buy.hidden = !sub;
      if (!sub) trip.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  form.querySelectorAll('input[name="id"]').forEach(function (r) { r.addEventListener('change', syncTier); });
  chk.addEventListener('change', syncConsent);

  /* « S'abonner » : la fenêtre d'abord, le panier ensuite. Capture sur le formulaire pour passer avant pj-cart.js. */
  form.addEventListener('submit', function (e) {
    if (confirmed) { confirmed = false; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    openModal();
  }, true);

  ok.addEventListener('click', function () {
    if (!chk.checked) {
      err.hidden = false;
      box.classList.remove('is-err'); void box.offsetWidth; box.classList.add('is-err');
      return;
    }
    val.value = val.getAttribute('data-base') + ' | ' + price() + ' | ' + new Date().toISOString();
    closeModal();
    confirmed = true;
    if (form.requestSubmit) form.requestSubmit(cta); else cta.click();
  });
  back.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

  /* Barre collante : la zone d'achat si « Moins d'un mois » est coché, la fenêtre sinon. */
  var bar = document.getElementById('stickyBar'), m = document.getElementById('mCta');
  if (m) {
    m.addEventListener('click', function (e) {
      e.preventDefault();
      if (buy.hidden) { fork.querySelector('[data-o="sub"]').click(); }
      openModal();
    });
  }
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var on = !es[es.length - 1].isIntersecting;
      bar.classList.toggle('is-stuck', on);
      document.body.classList.toggle('pj-sticky-on', on);
    }, { rootMargin: '0px 0px -8% 0px' }).observe(cta);
  }

  syncTier();
  syncConsent();
})();
